<template>
    <div class="picture-preview">
        <div class="preview-close" @click="handleClose">
            <i />
        </div>
        <div class="preview-container">
            <img :src="src" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'PicturePreview',
    props: {
        src: {
            type: String,
            default: '',
        },
    },
    methods: {
        handleClose() {
            this.$emit('close')
        },
    },
}
</script>

<style lang="scss" scoped>
.picture-preview {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 80px 0;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.6);

    .preview-close {
        position: absolute;
        top: 24px;
        right: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        cursor: pointer;
        transition: all 0.1s;
        border-radius: 18px;
        background: rgba(51, 51, 51, 0.5);
        backdrop-filter: blur(10px);

        i {
            width: 24px;
            height: 24px;
            background-image: url('@/assets/images/common/close@2x-white.png');
            background-repeat: no-repeat;
            background-size: cover;
        }

        &:hover {
            background: rgba(51, 51, 51, 0.8);
        }
    }

    .preview-container {
        display: flex;
        align-items: center;
        justify-content: center;

        max-width: min(calc(100% - 400px), 100%);
        height: 100%;
        margin: 0 auto;

        img {
            width: 100%;
        }

        @media screen and (max-width: 950px) {
            max-width: min(calc(100% - 160px), 100%);
        }

        @media screen and (max-width: 380px) {
            max-width: min(calc(100% - 40px), 100%);
        }
    }
}
</style>